export const getInitialState = () => ({
  loaded: false,
  channels: [],
});

export default getInitialState;
